import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5em;
  }

  .row-left {
    margin-bottom: 0.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .title_p {
    text-align: left;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75em;
    line-height: 1.8em;
    margin-bottom: 0.5em;
    color: ${Colors.Color7};
    ${props => props.row && `width: 6em; margin-bottom: 0em;`}
  }

  .novo-horario {
    cursor: pointer;
    padding: 0 1.7em;
    align-items: center;
    display: flex;
    justify-content: center;
    height: 2em;
    width: 8em;
    background-color: ${Colors.Color4};
    border: 0.25em solid ${Colors.Color4};
    border-radius: 0.5em;
    margin-right: 0.6em;

    .adiciona-horario {
      font-size: 0.88em;
      font-weight: 500;
      color: ${Colors.Color13};
    }
  }

  .footer {
    position: fixed;
    bottom: 1em;
    left: 1em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: ${localStorage.getItem('tema') == 'E'
      ? '0px 0px 19px 0px rgb(4 4 4 / 25%)'
      : '0px 0px 20px rgba(0,0,0,0.07)'} !important;
    margin-bottom: 1.5em;
    border-radius: 0.4em;
    padding: 0em 1em 0em 1em !important;

    .content-top {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;

      img {
        width: 24px;
        height: 24px;
        margin-bottom: 1em;
        cursor: pointer;
      }

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 31%;
        margin-top: 0.75em;
        margin-bottom: 1.25em;

        .cod {
          font-size: 0.75em;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }
    }
  }

  .atv-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: ${localStorage.getItem('tema') == 'E'
      ? '0px 0px 19px 0px rgb(4 4 4 / 25%)'
      : '0px 0px 20px rgba(0,0,0,0.07)'} !important;
    margin-bottom: 0.5em;
    border-radius: 0.4em;

    .atv-content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: ${Colors.Color23};
      border-radius: 0.4em;
      padding: 0.5em 1em 0.5em 1em;

      .card-titulo {
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        .titulo {
          font-size: 0.75em;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }

      .card-check {
        cursor: pointer;
        width: 1.5em;
        height: 1.5em;
        background: ${Colors.Color13};
        border-radius: 0.4em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .checked {
        span {
          width: 1em;
          height: 1em;
          background: ${Colors.Color4};
          display: block;
          border-radius: 0.3em;
        }
      }
    }

    .atv-content-body {
      margin-top: 0.5em;

      .col {
        margin-bottom: 0.5em !important;
      }
    }
  }
`;
